<template>
  <div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="消息类型">
        <el-select v-model="searchForm.msgType" placeholder="消息类型" :clearable="true">
          <el-option label="企微" :value="1"></el-option>
          <el-option label="邮件" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消息主题">
        <el-input v-model="searchForm.subject" placeholder="消息主题" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="消息接收域账号">
        <el-input v-model="searchForm.domainAccount" placeholder="消息接收域账号" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button type="primary" @click="onSearchReset">重置</el-button>
        <el-button type="primary" @click="onAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border style="width: 100%" v-loading="loading" stripe  max-height="700">
      <!-- <el-table-column prop="tenantId" label="系统ID" width="150"></el-table-column> -->
      <el-table-column prop="msgType" label="消息类型" width="150">
        <template slot-scope="scope">
          {{scope.row.msgType === 1 ? '企微' : scope.row.msgType === 3 ? '邮件' : ''}}
        </template>
      </el-table-column>
      <el-table-column prop="subject" label="消息主题"></el-table-column>
      <el-table-column prop="domainAccounts" label="消息接收域账号" width="250">
        <template slot-scope="scope" v-if="scope.row.domainAccount">
          <el-tag size="small" v-for="(item, i) of scope.row.domainAccount.split(',')" :key="i" style="margin-right: 5px">{{item}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="recipient" label="消息接收邮箱" width="250">
        <template slot-scope="scope" v-if="scope.row.recipient">
          <el-tag size="small" v-for="(item, i) of scope.row.recipient.split(',')" :key="i" style="margin-right: 5px">{{item}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateUserName" label="更新人" width="150"></el-table-column>
      <el-table-column prop="updateDate" label="更新时间" width="160" sortable></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleShowEditDialog(scope.row)">编辑</el-button>
          <el-popconfirm
            @confirm="handleDel(scope.row)"
            icon="el-icon-info"
            icon-color="red"
            title="确认删除吗？"
            style="margin-left: 0.625rem"
          >
            <el-button type="text" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="list.length" background layout="total, sizes, prev, pager, next, jumper" :total="total"
    :page-sizes="[15, 50, 100]" :page-size="pageSize" :current-page.sync="pageNum" @size-change="onChangeTable({pageSize: $event})"
    @current-change="onChangeTable({current: $event})" @prev-click="onChangeTable({current: $event})" @next-click="onChangeTable({current: $event})" />
    <el-dialog :title="!currentRow ? '新增': '修改'" :visible.sync="dialogVisible" width="600px" class="theme-config-dialog">
      <el-form :model="editForm" ref="ruleForm" label-width="140px" :rules="rules">
        <el-form-item label="消息类型" prop="msgType">
          <el-radio-group v-model="editForm.msgType">
            <el-radio :label="1">企微</el-radio>
            <el-radio :label="3">邮件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消息主题" prop="subject">
          <el-input v-model="editForm.subject" placeholder="请输入消息主题"/>
        </el-form-item>
        <el-form-item label="消息接收域账号">
          <el-button type="primary" icon="el-icon-plus" size="mini" @click="addDomainAccount" style="margin-bottom: 10px;"></el-button>
        </el-form-item>
        <el-form-item label="" 
          v-for="(item, index) in editForm.domainAccounts" 
          :prop="'domainAccounts.' + index"
          :rules="domainAccountRules"
          :key="'domain' + index" 
        > <div style="display: flex">
            <el-input v-model="editForm.domainAccounts[index]" placeholder="请输入消息接收域账号" style="width: 380px"/>
            <el-button type="danger" icon="el-icon-delete" @click="removeDomainAccount(index)" style="margin-left: 10px"></el-button>
          </div>
        </el-form-item>
        <el-form-item label="消息接收邮箱">
          <el-button  type="primary" icon="el-icon-plus" size="mini" @click="addRecipient" style="margin-bottom: 10px;"></el-button>
        </el-form-item>
        <el-form-item label="" 
          v-for="(item, index) in editForm.recipients" 
          :prop="'recipients.' + index" 
          :rules="emailRules" 
          :key="'email' + index"
        >
          <div style="display: flex">
            <el-input v-model="editForm.recipients[index]" placeholder="请输入消息接收邮箱" style="width: 380px"/>
            <el-button type="danger" icon="el-icon-delete" @click="removeRecipient(index)" style="margin-left: 10px"></el-button>
          </div>
        </el-form-item>
      </el-form>
      <p style="color: red; padding-left: 10px">注：如接收人无需管控，则不要进行配置；如需要管控，则必须配置所有允许发送的消息主题。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleAddOrEditSubmit" :loading="btnLoading">确 定</el-button>
        <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import httpUrl from "@/static/configUrl"
import userSelect from '@/components/userSelect'
import { debounce } from '@/util'
export default {
  components: {
    userSelect,
  },
  data() {
    return {
      searchForm: {
        msgType: '',
        subject: '',
        domainAccount: '',
      },
      list: [],
      dialogVisible: false,
      pageNum: 1,
      pageSize: 15,
      total: 0,
      loading: false,
      currentRow: null,
      editForm: {
        msgType: '',
        subject: '',
        domainAccounts: [],
        recipients: []
      },
      rules: {
        msgType: [
          { required: true, message: '请选择消息类型', trigger: ['blur', 'change'] }
        ],
        subject: [
          { required: true, message: '请输入消息主题', trigger: ['blur', 'change'] },
          { max: 50, message: '最大长度50', trigger: ['blur', 'change'] }
        ],
      },
      domainAccountRules: [
        { required: true, message: '请输入消息接收域账号', trigger: ['blur', 'change'] },
        { validator: (rule, value, callback) => {
            if (value) {
              const list = this.editForm.domainAccounts.filter(item => item === value)
              if (list.length > 1) {
                callback(new Error('域账号不能重复'))
              }
            }
            callback()
          }, trigger: 'blur' }
      ],
      emailRules: [
        { required: true, message: '请输入消息接收邮箱', trigger: ['blur', 'change'] },
        { pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/, message: '请输入正确的邮箱格式', trigger: ['blur', 'change'] },
        { validator: (rule, value, callback) => {
            if (value) {
              const list = this.editForm.recipients.filter(item => item === value)
              if (list.length > 1) {
                callback(new Error('邮箱不能重复'))
              }
            }
            callback()
          }, trigger: 'blur' }
      ],
      btnLoading: false,
    }
  },
  computed: {
    clientId(){
      return this.$store.state.request.appId
    }
  },
  created() {
    this.getList()
    this.debounceSearch = debounce(this.onSearch, 300)
  },
  watch: {
    dialogVisible() {
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    },
    searchForm: {
      handler() {
        this.debounceSearch()
      },
      deep: true,
    },
    clientId() {
      this.getList()
    }
  },
  methods: {
    onSearch() {
      this.pageNum = 1
      this.getList()
    },
    onSearchReset() {
      Object.keys(this.searchForm).forEach((key) => {
        this.searchForm[key] = null
      })
    },
    onAdd() {
      this.currentRow = null
      this.editForm = {
        msgType: '',
        subject: '',
        domainAccounts: [],
        recipients: []
      }
      this.dialogVisible = true
    },
    getList() {
      this.loading = true
      this.$store.dispatch('httpPost', {
        curl: httpUrl.messageUrl + "/subject/pageList",
        tenantId: this.$store.state.request.appId,
        isConsole: false,
        ...this.searchForm,
        page: this.pageNum,
        size: this.pageSize
      }).then((res) => {
        let list = res.data.content || []
        this.list = list
        this.total = parseInt(res.data.total)
        this.loading = false
      }, function (err) {
        console.log(err.message)
        this.loading = false
      })
    },
    handleShowEditDialog(row) {
      this.currentRow = row
      this.editForm = {
        msgType: row.msgType,
        subject: row.subject,
        domainAccounts: row.domainAccount ? row.domainAccount.split(',') : [],
        recipients: row.recipient ? row.recipient.split(',') : []
      }
      this.dialogVisible = true
    },
    addDomainAccount() {
      this.editForm.domainAccounts.push('')
    },
    removeDomainAccount(index) {
      this.editForm.domainAccounts.splice(index, 1)
    },
    addRecipient() {
      this.editForm.recipients.push('')
    },
    removeRecipient(index) {
      this.editForm.recipients.splice(index, 1)
    },
    handleAddOrEditSubmit() {
      this.$refs.ruleForm.validate((val) => {
        if (!val) return
        // 过滤空值并转为逗号分隔的字符串
        const domainAccounts = this.editForm.domainAccounts.filter(item => item)
        const recipients = this.editForm.recipients.filter(item => item)
        const params = {
          tenantId: this.$store.state.request.appId,
          msgType: this.editForm.msgType,
          subject: this.editForm.subject,
          domainAccounts,
          recipients
        }
        if (this.currentRow) {
          params.id = this.currentRow.id
          params.curl = httpUrl.messageUrl + "/subject/update"
        } else {
          params.curl = httpUrl.messageUrl + "/subject/add"
        }
        this.btnLoading = true
        this.$store.dispatch(this.currentRow ? 'httpPut': 'httpPost', params).then((res) => {
          this.getList()
          this.dialogVisible = false
          this.btnLoading = false
        }, function (err) {
          console.log(err.message)
        }).finally(() => {
          this.btnLoading = false
        })
      })
    },
    handleDel(row) {
      this.$store.dispatch('httpDelete', {
        curl: httpUrl.messageUrl + `/subject/delete/${row.id}`,
        clientId: this.$store.state.request.appId,
      }).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getList()
            }
          })
      }, function (err) {
        console.log(err.message)
      })
    },
    onChangeTable({ current, pageSize }) {
      this.pageSize = pageSize || this.pageSize
      this.pageNum = pageSize ? 1 : current || this.pageNum
      this.getList()
    },
  }
}
</script>
<style lang="scss">
.theme-config-dialog .el-dialog .el-dialog__body .el-form-item__content {
  width: unset !important;
}
</style>
